export const TERMS_DOCUMENT_URL_FETCH_TIMEOUT_MS = 30_000;
export const SCROLL_END_THRESHOLD_PX = 8;
export const TERMS_SESSION_UI_ACK_STORAGE_KEY = 'ibk-terms-acceptance-acknowledged';
export const TERMS_ACCEPTANCE_LOG_PREFIX = '[ibk/terms-acceptance]';
export const TERMS_IFRAME_TYPOGRAPHY_STYLE_ELEMENT_ID = 'ibk-terms-iframe-typography';
export const TERMS_ACCEPTANCE_GATE_DEFAULT_TEST_ID = 'terms-acceptance';
export const TERMS_ACCEPTANCE_MODAL_DEFAULT_TEST_ID = 'terms-acceptance-modal';
export const PLATFORM_TERMS_ACCEPT_ORIGIN_LOGIN = 'Login';
